import styles from './footer.module.css'

const Footer = () => {
  return <div className={styles.footer}></div>
}

export default Footer
